import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import Lottie from "react-lottie";
import { Container } from "reactstrap";
import * as setDataloading from "./setDataloading.json";

function SetDataloading() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: setDataloading.default,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <React.Fragment>
      {/* {!loading ?  */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <FadeIn>
          <Lottie options={defaultOptions} width={450} height={350} />
        </FadeIn>
      </div>
    </React.Fragment>
  );
}

export default SetDataloading;
